import { render, staticRenderFns } from "./SelectPersonsDialog.vue?vue&type=template&id=4aa8ff24&scoped=true"
import script from "./SelectPersonsDialog.vue?vue&type=script&lang=js"
export * from "./SelectPersonsDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectPersonsDialog.vue?vue&type=style&index=0&id=4aa8ff24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa8ff24",
  null
  
)

export default component.exports